module.exports = __webpack_public_path__ + "static/media/changes and reels.07f9dbea.png";